import {
  FEEDBACK_INSIGHTS_OVERVIEW,
  FEEDBACK_INSIGHTS_RATING_TREND,
  FEEDBACK_INSIGHTS_SERVICE_PERIOD,
  FEEDBACK_INSIGHTS_OUTLET_COMPARISON,
} from 'constants/api';
import { fetchRequest } from 'helpers/actionsFormat';

export const getFeedbackInsightsOverview = payload =>
  fetchRequest(FEEDBACK_INSIGHTS_OVERVIEW, payload);

export const getFeedbackInsightsRatingTrend = payload =>
  fetchRequest(FEEDBACK_INSIGHTS_RATING_TREND, payload);

export const getFeedbackInsightsServicePeriod = payload =>
  fetchRequest(FEEDBACK_INSIGHTS_SERVICE_PERIOD, payload);

export const getFeedbackInsightsOutletComparison = payload =>
  fetchRequest(FEEDBACK_INSIGHTS_OUTLET_COMPARISON, payload);
